import React from "react";
import { MdOutlineNoCrash } from "react-icons/md";

const NoOnlineDrivers = ({ goBackToBooking }) => {
    console.log("in no online drivers")
  return (
    <div className="flex justify-center items-center ">
    <div className="w-full max-w-mdshadow-lg rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm md:text-base text-gray-600 dark:text-gray-300 max-w-[80%]">
          There are no drivers online at this moment for your preferences.
        </p>
        <MdOutlineNoCrash className="text-gray-500 dark:text-gray-400 text-4xl" />
      </div>

      <div className="flex justify-center">
        <button
          onClick={goBackToBooking}
          className="bg-blue-500 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded transition"
        >
          Edit your preferences
        </button>
      </div>
    </div>
  </div>
  );
};

export default NoOnlineDrivers;
